(() => {
  const sectionSelector = '[data-collection-metafield-carousel-section]';

  if (window.CollectionMetafieldCarouselSection) {
    window.CollectionMetafieldCarouselSection.init();
    return;
  }

  class CollectionMetafieldCarouselSection {
    constructor(section) {
      this.section = section;
    }

    destroy() {}
  }

  const instances = new WeakMap();

  function getSections(root = document) {
    if (root instanceof Element && root.matches(sectionSelector)) {
      return [root];
    }

    return Array.from(root.querySelectorAll(sectionSelector));
  }

  function init(root = document) {
    getSections(root).forEach((section) => {
      if (instances.has(section)) {
        return;
      }

      instances.set(section, new CollectionMetafieldCarouselSection(section));
    });
  }

  function destroy(root = document) {
    getSections(root).forEach((section) => {
      const instance = instances.get(section);

      if (!instance) {
        return;
      }

      instance.destroy();
      instances.delete(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));

  window.CollectionMetafieldCarouselSection = {
    init,
    destroy
  };
})();
